import {useState} from 'react'
import {getGuestsService} from '../../hoteleria/services/guest.service'
import {SelectModel} from '../model'
import {GetPaginationGuestDto} from '../../hoteleria/features/guests/model'
const useGuestList = () => {
  const [loading, setLoading] = useState(false)
  const [guest, setGuest] = useState<SelectModel[]>([])

  const getGuestsServiceAPI = async (guestParams: GetPaginationGuestDto) => {
    let obj = {
      isCombo: true,
      ...guestParams,
    }
    return await getGuestsService(obj)
  }

  const getGuestsServiceData = async (guestParams: GetPaginationGuestDto) => {
    setLoading(true)
    try {
      const response = await getGuestsServiceAPI(guestParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching service data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }
  const mapDataSelect = (data: any[]) =>
    data.map((item) => ({
      value: item.Id,
      label: `${item.ApellidoPaterno} ${item.ApellidoMaterno} ${item.Nombres} (${item.TipoDocumento_descripcion} ${item.NumeroDocumento})`,
      ...item,
    }))

  const updateGuestList = (mappedSites: {value: string; label: string}[]) => {
    setGuest(mappedSites)
  }

  const getGuestsServiceList = async (guestParams: GetPaginationGuestDto) => {
    try {
      const data = await getGuestsServiceData(guestParams)
      const mappedSites = mapDataSelect(data)
      updateGuestList(mappedSites)
    } catch (error) {
      console.error('Error fetching service data:', error)
    }
  }

  const handleClear = () => {
    setGuest([])
  }

  return {
    loading,
    guest,
    getGuestsServiceList,
    getGuestsServiceData,
    handleClear,
  }
}

export default useGuestList
